<app-login-modal></app-login-modal>
<app-register-modal></app-register-modal>
<app-order-modal></app-order-modal>
<app-nav></app-nav>

<router-outlet></router-outlet>

<div class="spinner" *ngIf="displayLoadingIndicator"></div>

